import { useEffect } from 'react'
import { useUIStore } from '../stores/uiStore'

export const useThemeInitialization = () => {
  const theme = useUIStore((state) => state.theme)

  useEffect(() => {
    // Apply theme to DOM on component mount and when theme changes
    const root = document.documentElement
    if (theme === 'dark') {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }, [theme])

  // Initialize theme from localStorage on app start
  useEffect(() => {
    // This will run once on app start
    // Zustand persist will have already loaded the theme from localStorage
    // We just need to ensure it's applied to the DOM
    const currentTheme = useUIStore.getState().theme
    const root = document.documentElement

    if (currentTheme === 'dark') {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }, [])
}
